import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { FORMULA_FIELDS } from './salesData';
import { PHOTOS } from '../data/photos';
export function FormulaSection() {
  return <section id="dentro-de-una-formula" className="bg-white py-11 sm:py-14" data-id="element-104" data-mp="2n3buailjk1f8">
      <div className="mx-auto max-w-md px-5 sm:max-w-3xl" data-id="element-105" data-mp="2rvlgbnjjchc8">
        <div className="text-center" data-id="element-106" data-mp="2rx6avd5uo0a3">
          <h2 className="mx-auto max-w-[20ch] font-display text-[1.4rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:text-[2rem]" data-id="element-107" data-mp="2vx6o4uh7q5fk">
            Abrís una fórmula y <span className="text-gold-deep" data-id="element-108" data-mp="30xkyij6adrgr">sabés qué hacer</span>
          </h2>
          <p className="mx-auto mt-2.5 max-w-[36ch] font-sans text-[0.86rem] leading-relaxed text-taupe" data-id="element-109" data-mp="35vmf8xg8pep2">
            Las 200 fórmulas tienen la misma ficha completa.
          </p>
        </div>

        <div className="mt-5 sm:grid sm:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] sm:items-start sm:gap-4" data-id="element-110" data-mp="1bio8uoxnv270">
          <img src={PHOTOS.macro} alt="Detalle macro de un jabón de glicerina translúcido con lavanda en su interior" loading="lazy" decoding="async" className="h-32 w-full rounded-xl object-cover sm:h-full sm:min-h-[13rem]" data-id="element-111" data-mp="1gi0vb8kme792" />

          <motion.ul initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-1.5 grid grid-cols-2 gap-1.5 sm:mt-0" data-id="element-112" data-mp="1fgg2y2422s1t">
            {FORMULA_FIELDS.map(field => <li key={field} className="flex items-start gap-2 rounded-xl bg-cream px-3 py-2.5 font-sans text-[0.78rem] font-semibold leading-tight text-charcoal" data-id="element-113" data-mp="1y7z5k7u6443b">
                <CheckIcon className="mt-px h-3.5 w-3.5 shrink-0 text-gold" aria-hidden strokeWidth={3} data-id="element-114" data-mp="mumyzp70x7dg" />
                {field}
              </li>)}
          </motion.ul>
        </div>

        <div className="mt-4 rounded-2xl border border-gold bg-gold-soft px-4 py-4 sm:px-5" data-id="element-115" data-mp="kaqjh0nt3g0h">
          <h3 className="font-display text-[0.92rem] font-bold leading-tight text-charcoal sm:text-[1rem]" data-id="element-116" data-mp="p777zvyx3we3">
            🧼 Fórmulas con base de glicerina
          </h3>
          <p className="mt-1.5 font-sans text-[0.83rem] leading-relaxed text-taupe" data-id="element-117" data-mp="f9t38tmcww1m">
            Aprendé a crear jabones artesanales utilizando base de glicerina, sin realizar el proceso
            tradicional de saponificación con soda cáustica.
          </p>
          <p className="mt-1.5 font-sans text-[0.8rem] font-semibold leading-snug text-gold-deep" data-id="element-118" data-mp="6bqx5znrnd7h">
            Una forma más simple y práctica de empezar, especialmente si nunca hiciste jabones antes.
          </p>
        </div>
      </div>
    </section>;
}